import { Suspense, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Navbar from '../../component/Navbar';
import Sidebar from '../../component/Sidebar';
import { activeSession, getUserPermissions, savePermissions } from '../../redux/reducers/authSlice';
import { logout } from '../../service/helpers';
import { currentPillar } from '../../redux/reducers/adminSlice';

const DashboardLayout = ({ children }) => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(activeSession);
  const userPillar = useSelector(currentPillar);
  const permissions = useSelector((state) => state?.auth?.permissions);

  // Fetch fresh permissions on page load/refresh
  useEffect(() => {
    if (isAuthenticated) {
      const fetchPermissions = async () => {
        try {
          const response = await getUserPermissions();
          if (response?.data?.permissions) {
            dispatch(savePermissions(response.data.permissions));
          }
        } catch (error) {
          console.error('Error fetching permissions:', error);
          // If permission fetch fails (e.g., token expired), logout
          if (error?.response?.status === 401 || error?.response?.status === 403) {
            logout();
          }
        }
      };

      fetchPermissions();
    }
  }, [isAuthenticated, dispatch]);

  useEffect(() => {
    if (!isAuthenticated && permissions && permissions?.length > 0) {
      logout();
    }
  }, [isAuthenticated, userPillar]);

  return (
    isAuthenticated && (
      <div className='flex h-screen overflow-hidden bg-light-bg'>
        <Sidebar />

        <div
          className='flex-1 flex flex-col overflow-hidden
                            w-[calc(100%-250px)] max-md:w-full'
        >
          <div className='sticky top-0 z-30'>
            <Navbar />
          </div>

          <div className='flex-1 overflow-y-auto'>
            <div
              className='p-3 px-5 flex flex-col layout-wrapper
                                    pt-3 max-md:pt-16'
            >
              <Suspense fallback={null}>{children}</Suspense>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default DashboardLayout;
